module.exports = require("@wildboar/x500/src/lib/modules/HierarchicalOperationalBindings/SubentryInfo.ta");